import { useState } from 'react';
import { IErrorResponse, toast } from '@datapeace/1up-frontend-web-ui';
import { useProcessDataContext } from '@datapeace/vms-visitor-models';
import { isConsentDisabledOrg } from '@datapeace/vms-visitor-utils';
import styles from '../custom-form-screen/custom-form-screen.module.scss';
import {
  Layout,
  Header,
  Content,
  Form,
  DynamicForm,
  NavButtons,
  ConsentCard,
} from '@datapeace/vms-visitor-components';

export const CheckinByMobile = () => {
  const {
    countryCallingCode,
    handleSendOtpToMobile,
    goBack,
    updateProcessData,
    consentConfig,
    orgId,
  } = useProcessDataContext();

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ mobileNumber: '' });

  const hasConsentConfig =
    !isConsentDisabledOrg(orgId) &&
    !!consentConfig?.consent &&
    Object.keys(consentConfig.consent).length > 0;
  const [consentGiven, setConsentGiven] = useState(!hasConsentConfig);

  const handleConsentChange = (given: boolean, timestamp?: string) => {
    setConsentGiven(given);
    updateProcessData({ consentProvidedAt: timestamp ?? null });
  };

  const handleSubmit = async () => {
    if (!consentGiven) return;
    const { mobileNumber } = formData;
    try {
      setIsLoading(true);
      await handleSendOtpToMobile(mobileNumber);
    } catch (err) {
      setIsLoading(false);
      toast.error(err as IErrorResponse);
    }
  };

  const formSchema = [
    {
      type: 'tel',
      defaultPrefix: countryCallingCode,
      name: 'mobileNumber',
      label: 'Enter your mobile number',
      required: true,
      disablePrefix: true,
    },
  ];

  return (
    <Layout>
      <Header />
      <Content>
        <div className={styles.Form}>
          <Form onSubmit={handleSubmit} noValidate autoComplete="off">
            <ConsentCard
              consentConfig={consentConfig}
              consentGiven={consentGiven}
              setConsentGiven={handleConsentChange}
            />
            <DynamicForm
              values={formData}
              items={formSchema}
              onChange={setFormData}
            />
            <NavButtons
              loading={isLoading}
              goBack={goBack}
              isDisabled={!consentGiven}
            />
          </Form>
        </div>
      </Content>
    </Layout>
  );
};
